/**
 * Reporting form composer shape + defaults (shared by Redux + localStorage restore).
 */

import {
  createInitialDescriptionBlocks,
  ReportDescriptionBlock,
} from './reportDescriptionBlocks';
import { ReportSelectedActivity } from './reportSelectedActivity';

/** New reports: details first, then body. Replies start on body. */
export type ReportingComposerPhase = 'details' | 'body';

export type PreparedReportDraft = {
  id: string,
  viewUrl?: string | null,
  preview?: string,
};

/** Composer form — kept in Redux + localStorage so refresh restores it (per staff, not shared). */
export type ReportingComposerState = {
  toEmail: string,
  /** Mandatory one-line subject for the report. */
  subject: string,
  descBlocks: ReportDescriptionBlock[],
  activeTextBlockId: string,
  draft: PreparedReportDraft | null,
  /** Inbox report being answered — locks Send to / Purpose. */
  replyToReportId: string | null,
  replyToFromName: string,
  /** New-report wizard step. Replies always use body. */
  composerPhase: ReportingComposerPhase,
  /** Activity scope tokens for searchlogs (clears selectedActivity when changed). */
  activityScopeChecked: string[],
  /** Human scope key for restoring the scope dropdown. */
  activityScopeKey: string,
  /** Activity pinned on this report (details step). */
  selectedActivity: ReportSelectedActivity | null,
};

export const createDefaultReportingComposer = (): ReportingComposerState => ({
  toEmail: '',
  subject: '',
  descBlocks: createInitialDescriptionBlocks(),
  activeTextBlockId: '',
  draft: null,
  replyToReportId: null,
  replyToFromName: '',
  composerPhase: 'details',
  activityScopeChecked: [],
  activityScopeKey: '',
  selectedActivity: null,
});
